var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrainingProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9386 3.0535C22.945 3.0535 23.7585 3.87196 23.7585 4.88955V16.4897L24.3671 15.879H3.06098C2.05454 15.879 1.24108 15.0605 1.24108 14.0429V2.44277L0.632504 3.0535H21.9386ZM0.0239258 1.83203V2.44277V14.0429C0.0239258 15.7344 1.38162 17.1004 3.06098 17.1004H24.3671H24.9756V16.4897V4.88955C24.9756 3.19807 23.618 1.83203 21.9386 1.83203H0.632504H0.0239258Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54195 23.9756C4.31445 24.2239 4.33059 24.6103 4.57801 24.8386C4.82542 25.0669 5.21041 25.0507 5.43791 24.8024L10.9511 18.7854C11.1786 18.5371 11.1625 18.1507 10.9151 17.9224C10.6676 17.6941 10.2827 17.7103 10.0552 17.9586L4.54195 23.9756Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7031 24.8024C19.9306 25.0507 20.3156 25.0669 20.563 24.8386C20.8104 24.6103 20.8266 24.2239 20.5991 23.9756L15.0859 17.9586C14.8584 17.7103 14.4734 17.6941 14.226 17.9224C13.9785 18.1507 13.9624 18.5371 14.1899 18.7854L19.7031 24.8024Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7334 2.57495C10.7334 2.83934 11.0059 3.05368 11.342 3.05368C11.6781 3.05368 11.9506 2.83934 11.9506 2.57495V0.478729C11.9506 0.214334 11.6781 0 11.342 0C11.0059 0 10.7334 0.214334 10.7334 0.478729V2.57495Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5705 7.63065C12.9066 7.63065 13.179 7.35721 13.179 7.01991C13.179 6.68262 12.9066 6.40918 12.5705 6.40918H3.61151C3.2754 6.40918 3.00293 6.68262 3.00293 7.01991C3.00293 7.35721 3.2754 7.63065 3.61151 7.63065H12.5705Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5705 11.5618C12.9066 11.5618 13.179 11.2884 13.179 10.9511C13.179 10.6138 12.9066 10.3403 12.5705 10.3403H3.61151C3.2754 10.3403 3.00293 10.6138 3.00293 10.9511C3.00293 11.2884 3.2754 11.5618 3.61151 11.5618H12.5705Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7332 13.7273C17.9554 12.7787 18.6923 11.3489 18.6923 9.39993V5.38857C18.6923 5.05127 18.4198 4.77783 18.0837 4.77783C17.7476 4.77783 17.4752 5.05127 17.4752 5.38857V9.39993C17.4752 10.9609 16.9199 12.0382 15.9886 12.761C15.6613 13.015 15.3087 13.2065 14.9569 13.3431C14.7505 13.4232 14.5965 13.4659 14.5225 13.4802C14.1925 13.5442 13.9767 13.8646 14.0405 14.1958C14.1043 14.5269 14.4235 14.7435 14.7535 14.6795C15.2698 14.5793 16.0008 14.2956 16.7332 13.7273Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5523 5.77796C18.7666 5.51811 18.7304 5.13312 18.4715 4.91807C18.2125 4.70302 17.8289 4.73935 17.6146 4.99921L14.858 8.34201C14.6437 8.60186 14.6799 8.98685 14.9389 9.2019C15.1978 9.41695 15.5814 9.38062 15.7957 9.12076L18.5523 5.77796Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5525 4.99921C18.3383 4.73935 17.9546 4.70302 17.6957 4.91807C17.4368 5.13312 17.4006 5.51811 17.6148 5.77796L20.3714 9.12076C20.5857 9.38062 20.9694 9.41695 21.2283 9.2019C21.4872 8.98685 21.5234 8.60186 21.3091 8.34201L18.5525 4.99921Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrainingProgram);
export default __webpack_public_path__ + "static/media/ic_training_program.d00e56e5708f2d823e2d9006ea5a0769.svg";
export { ForwardRef as ReactComponent };